import React from 'react';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import { useTheme as useCustomTheme } from '../theme/ThemeProvider';

const AboutUs = () => {
    const theme = useTheme();
    const { darkMode } = useCustomTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detect mobile view

    return (
        <section style={{ paddingInline: isMobile ? '20px' : '200px', marginBottom: '50px' }}>
            {/* About Us Card */}
            <Card
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row', // Stack content for mobile
                    borderRadius: '15px',
                    backgroundColor: darkMode ? '#2d3748' : '#f5f5f5',
                    color: darkMode ? '#e2e8f0' : '#1a202c',
                    overflow: 'hidden',
                    marginBottom: '75px',
                    border: darkMode ? '1px solid #4a5568' : 'none',
                    boxShadow: darkMode ? '0 4px 20px rgba(0, 0, 0, 0.3)' : '0 4px 20px rgba(0, 0, 0, 0.1)',
                }}
            >
                <CardMedia
                    component="img"
                    style={{
                        width: isMobile ? '100%' : '40%', // Full width on mobile
                        height: 'auto',
                        objectFit: 'cover',
                        padding: isMobile ? '10px' : '20px',
                    }}
                    image={require('../assets/images/about.webp')}
                    alt="About Us"
                />
                <CardContent style={{ width: isMobile ? '100%' : '50%' }}>
                    <Typography variant="h5" align="center" marginBottom="25px" style={{ color: darkMode ? '#f7fafc' : '#1a202c' }}>
                        About Us
                    </Typography>
                    <Typography variant="body2" style={{ color: darkMode ? '#cbd5e0' : '#4a5568' }} align="left" paddingRight={isMobile ? '20px' : '0px'}>
                        We are a dynamic team committed to revolutionizing how people interact with and analyze text.
                        Our journey began with the idea of empowering creators, businesses, and individuals with tools that make
                        handling text-related tasks more intuitive, efficient, and accessible. By leveraging advanced technologies
                        and listening to user feedback, we continue to innovate and refine our solutions to meet your evolving needs.
                    </Typography>
                </CardContent>
            </Card>

            {/* Mission Card */}
            <Card
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column-reverse' : 'row', // Reverse layout for mobile
                    borderRadius: '15px',
                    backgroundColor: darkMode ? '#2d3748' : '#f5f5f5',
                    color: darkMode ? '#e2e8f0' : '#1a202c',
                    overflow: 'hidden',
                    marginBottom: '75px',
                    border: darkMode ? '1px solid #4a5568' : 'none',
                    boxShadow: darkMode ? '0 4px 20px rgba(0, 0, 0, 0.3)' : '0 4px 20px rgba(0, 0, 0, 0.1)',
                }}
            >
                <CardContent style={{ width: isMobile ? '100%' : '50%' }}>
                    <Typography variant="h5" align="center" marginBottom="25px" style={{ color: darkMode ? '#f7fafc' : '#1a202c' }}>
                        Our Mission
                    </Typography>
                    <Typography variant="body2" style={{ color: darkMode ? '#cbd5e0' : '#4a5568' }} align="left" paddingRight={isMobile ? '20px' : '0px'}>
                        Our mission is to bridge the gap between complex text processing and everyday users, delivering seamless,
                        user-friendly tools that simplify tasks like text analysis, sentiment detection, and AI text generation.
                        We aim to empower individuals and organizations to communicate more effectively, save time, and unlock
                        the full potential of their creativity and data.
                    </Typography>
                </CardContent>
                <CardMedia
                    component="img"
                    style={{
                        width: isMobile ? '100%' : '40%',
                        height: 'auto',
                        objectFit: 'cover',
                        padding: isMobile ? '10px' : '20px',
                    }}
                    image={require('../assets/images/mission.webp')}
                    alt="Our Mission"
                />
            </Card>

            {/* Vision Card */}
            <Card
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    borderRadius: '15px',
                    backgroundColor: darkMode ? '#2d3748' : '#f5f5f5',
                    color: darkMode ? '#e2e8f0' : '#1a202c',
                    overflow: 'hidden',
                    marginBottom: '75px',
                    border: darkMode ? '1px solid #4a5568' : 'none',
                    boxShadow: darkMode ? '0 4px 20px rgba(0, 0, 0, 0.3)' : '0 4px 20px rgba(0, 0, 0, 0.1)',
                }}
            >
                <CardMedia
                    component="img"
                    style={{
                        width: isMobile ? '100%' : '40%',
                        height: 'auto',
                        objectFit: 'cover',
                        padding: isMobile ? '10px' : '20px',
                    }}
                    image={require('../assets/images/vision.webp')}
                    alt="Our Vision"
                />
                <CardContent style={{ width: isMobile ? '100%' : '50%' }}>
                    <Typography variant="h5" align="center" marginBottom="25px" style={{ color: darkMode ? '#f7fafc' : '#1a202c' }}>
                        Our Vision
                    </Typography>
                    <Typography variant="body2" style={{ color: darkMode ? '#cbd5e0' : '#4a5568' }} align="left" paddingRight={isMobile ? '20px' : '0px'}>
                        Our vision is to become the go-to platform for text-related solutions worldwide. We envision a future where
                        everyone, regardless of technical expertise, can harness the power of advanced text technologies to achieve
                        their goals. By fostering a culture of innovation, inclusivity, and sustainability, we strive to make a lasting
                        positive impact on individuals, communities, and industries.
                    </Typography>
                </CardContent>
            </Card>
        </section>
    );
};

export default AboutUs;
